import { createStore } from 'zustand/vanilla';
function getOrCreateInstance(templates, templateName) {
    const existing = templates.get(templateName);
    if (existing)
        return existing;
    const instance = {
        containers: new Map(),
        slotProps: new Map(),
        activeSlots: new Map(),
    };
    templates.set(templateName, instance);
    return instance;
}
export const templateEngineStore = createStore((set, get) => ({
    templates: new Map(),
    registerContainer(templateName, slotKey, node) {
        const { templates } = get();
        const instance = getOrCreateInstance(templates, templateName);
        instance.containers.set(slotKey, node);
        set({ templates: new Map(templates) });
    },
    unregisterContainer(templateName, slotKey) {
        const { templates } = get();
        const instance = templates.get(templateName);
        if (!instance)
            return;
        instance.containers.delete(slotKey);
        instance.slotProps.delete(slotKey);
        set({ templates: new Map(templates) });
    },
    setSlotActive(templateName, slotKey, active) {
        const { templates } = get();
        const instance = active
            ? getOrCreateInstance(templates, templateName)
            : templates.get(templateName);
        if (!instance)
            return;
        const currentCount = instance.activeSlots.get(slotKey) ?? 0;
        if (active) {
            instance.activeSlots.set(slotKey, currentCount + 1);
        }
        else if (currentCount > 1) {
            instance.activeSlots.set(slotKey, currentCount - 1);
        }
        else {
            instance.activeSlots.delete(slotKey);
        }
        set({ templates: new Map(templates) });
    },
    setSlotProps(templateName, batch) {
        const { templates } = get();
        const instance = getOrCreateInstance(templates, templateName);
        for (const [slotName, props] of Object.entries(batch)) {
            instance.slotProps.set(slotName, props);
        }
        set({ templates: new Map(templates) });
    },
    getContainer(templateName, slotName) {
        return get().templates.get(templateName)?.containers.get(slotName) ?? null;
    },
    reset() {
        set({ templates: new Map() });
    },
}));
//# sourceMappingURL=templateEngineStore.js.map